export const treeTableStyles = {
  headerRow: {
    backgroundColor: "var(--mb-color-background_page-secondary)",
  },
};
